class Grid {
    constructor($scope, config) {
        this.config = Object.assign({
            checkbox: 'input[type="checkbox"]',
            searchToggle: '.download-btn',
            searchClose: '.search-close-download',
            counter: '#numberDisplay',
            searchPanel: '.download_search',
        }, config);

        this.$scope = $scope;

        this.init();
    }

    init() {
        this.updateCheckedCount();
        this.$scope.on('change', this.config.checkbox, this.updateCheckedCount.bind(this));
        this.$scope.on('click', this.config.searchToggle, this.toggleSearch.bind(this));
        this.$scope.on('click', this.config.searchClose, this.toggleSearch.bind(this));
    }

    updateCheckedCount() {
        const count = this.$scope.find(this.config.checkbox + ':checked').length;
        this.$scope.find(this.config.counter).text(count);
    }

    toggleSearch() {
        this.$scope.find(this.config.searchPanel).toggleClass('d-none');
    }
}

export default {
    init() {
        $('[data-download-contentable="group"]').each(function () {
            new Grid($(this));
        });
    }
};